const eventFuncMap = {};
export function addEventListener(key, func) {
    const target = (eventFuncMap[key] = eventFuncMap[key] || []);
    if (target.indexOf(func) > -1) {
        throw new Error("auth.addEventListener: 同一个方法注册了多次");
    }
    if ("function" !== typeof func) {
        throw new Error("auth.addEventListener: 只允许传入函数");
    }
    target.push(func);
}
export function removeEventListener(key, func) {
    eventFuncMap[key] = (eventFuncMap[key] || []).filter(one => one !== func);
}

export function emit(key) {
    const list = eventFuncMap[key] || [];
    list.forEach(func => func());
}
